module.exports = __webpack_public_path__ + "d298a3e5b31de199770e0bde43db51e4.glb";